/** Built-in workflow statuses (stored on each ticket as `status`). */
export const TICKET_STATUSES = [
  { id: 'open', label: 'Open' },
  { id: 'in_progress', label: 'In progress' },
  { id: 'waiting', label: 'Waiting' },
  { id: 'blocked', label: 'Blocked' },
  { id: 'waiting_on_dependencies', label: 'Waiting on dependencies' },
  { id: 'awaiting_hq_verification', label: 'Awaiting HQ Verification' },
  { id: 'awaiting_human_intervention', label: 'Awaiting human intervention' },
  { id: 'pending_hq_approval', label: 'Pending HQ approval' },
  { id: 'escalated', label: 'Escalated' },
  { id: 'resolved', label: 'Resolved' },
  { id: 'closed', label: 'Closed' },
  { id: 'quota_blocked', label: 'Quota blocked' },
];

export function statusLabel(id) {
  return TICKET_STATUSES.find((s) => s.id === id)?.label || id || '—';
}

export const PRIORITIES = [
  { id: 'low', label: 'Low' },
  { id: 'medium', label: 'Medium' },
  { id: 'high', label: 'High' },
];

export function priorityLabel(id) {
  return PRIORITIES.find((p) => p.id === id)?.label || id || 'Medium';
}
